<div class="countdown-timer">
  <div class="countdown-header">
    <h4>{{ 'countdown.quickcoach.shutdown.title' | translate }}</h4>
    <p>{{ 'countdown.quickcoach.shutdown.message' | translate }}</p>
  </div>

  <div class="countdown-display">
    <div class="time-unit">
      <span class="time-value" id="days">00</span>
      <span class="time-label">{{ 'countdown.time.days' | translate }}</span>
    </div>
    <div class="time-separator">:</div>
    <div class="time-unit">
      <span class="time-value" id="hours">00</span>
      <span class="time-label">{{ 'countdown.time.hours' | translate }}</span>
    </div>
    <div class="time-separator">:</div>
    <div class="time-unit">
      <span class="time-value" id="minutes">00</span>
      <span class="time-label">{{ 'countdown.time.minutes' | translate }}</span>
    </div>
    <div class="time-separator">:</div>
    <div class="time-unit">
      <span class="time-value" id="seconds">00</span>
      <span class="time-label">{{ 'countdown.time.seconds' | translate }}</span>
    </div>
  </div>

  <div class="countdown-footer">
    <p><strong>{{ 'countdown.quickcoach.shutdown.cta' | translate }}</strong></p>
  </div>
</div>
